<template>
  <div class="subscription_section">
    <div class="mb-5">
      <h2 class="text-content-center xxlg--text">Subscription Plans</h2>
    </div>
    <v-tabs
        class="mb-4"
        v-model="current_tab"
        color="deep-purple-accent-4"
        fixed-tabs
    >
      <v-tab :value="0">Web Scraping API</v-tab>
      <v-tab :value="1">Residential Proxies</v-tab>
      <v-tab :value="2">Datacenter Proxies</v-tab>
    </v-tabs>
      <v-tabs-items v-model="current_tab">
        <v-tab-item :key="0">
          <v-row no-gutters class="mb-4">
            <v-col
                class="pb-8"
                v-for="plan in plans"
                :key="plan.id"
                lg="3"
                md="6"
                sm="16"
                cols="12"
            >
              <v-card class="pricing-item border-radius-8 mx-4 pb-4">
                <v-card-title class="box-shadow-none subscribed pricing-header pt-6" :style="[plan.can_cancel ? {'background-color': '#2ECC71'} : {}]">
                  <div class="pricing-title">{{ plan.name }}</div>
                  <div class="pricing-subtitle">
                    {{ plan.credits | currency("", 0) }} API credits
                  </div>
                </v-card-title>
                <v-card-text class="pricing-body px-4">
                  <div class="plan-price">
                    <b v-if="plan.price !== 0">
                      <sup>$</sup>{{ (plan.price / 100) | currency("", 0) }}
                    </b>
                    <b v-else>Free</b>
                    <span :style="[plan.can_cancel ? {'color': '#2ECC71'} : {}]">Monthly</span>
                  </div>
                  <v-list class="mx-0 px-0">
                    <v-list-item
                        class="height-48"
                        v-for="(feature, index) in plan.features"
                        :key="feature.name + index"
                    >
                      <v-list-item-icon class="mr-5 mt-3">
                        <v-icon v-if="feature.included" color="primary"
                        >mdi-check</v-icon
                        >
                        <v-icon v-else color="primary" class="lg--text"
                        >mdi-block-helper</v-icon
                        >
                      </v-list-item-icon>
                      <v-list-item-content class="text-left">
                        <v-list-item-title class="white-space">{{
                            feature.name
                          }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
                <v-card-actions class="custom-center justify-center">
                  <a
                      v-if="!plan.can_cancel"
                      class="btn cta"
                      :class="{ disabled: !plan.can_subscribe }"
                      @click="() => start_checkout(plan.product_id)"
                  >
                    {{ get_subscribe_button_text(plan) }}
                  </a>
                  <a
                      v-else
                      class="btn cta error"
                      :class="{ disabled: plan.price === 0 }"
                      @click="show_cancel_dialogue"
                  >
                    Cancel
                  </a>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item :key="1">
          <v-row no-gutters class="mb-4">
            <v-col
                class="pb-8"
                v-for="plan in residential_plans"
                :key="plan.id"
                lg="3"
                md="6"
                sm="16"
                cols="12"
            >
              <v-card class="pricing-item border-radius-8 mx-4 pb-4">
                <v-card-title class="box-shadow-none subscribed pricing-header pt-6" :style="[plan.can_cancel ? {'background-color': '#2ECC71'} : {}]">
                  <div class="pricing-title">{{ plan.name }}</div>
                  <div class="pricing-subtitle">
                    {{ plan.traffic_amount_gb | currency("", 0) }} GBs
                  </div>
                </v-card-title>
                <v-card-text class="pricing-body px-4">
                  <div class="plan-price">
                    <b v-if="plan.price !== 0">
                      <sup>$</sup>{{ (plan.price / 100) | currency("", 0) }}
                    </b>
                    <b v-else>Free</b>
                    <span :style="[plan.can_cancel ? {'color': '#2ECC71'} : {}]">Monthly</span> <br>
                    <span :style="{ color: '#000000a0' }"><sup>$</sup>{{ plan.price / plan.traffic_amount_gb / 100 }}/GB</span>
                  </div>
                  <v-list class="mx-0 px-0">
                    <v-list-item
                        class="height-48"
                        v-for="(feature, index) in plan.features"
                        :key="feature.name + index"
                    >
                      <v-list-item-icon class="mr-5 mt-3">
                        <v-icon v-if="feature.included" color="primary"
                        >mdi-check</v-icon
                        >
                        <v-icon v-else color="primary" class="lg--text"
                        >mdi-block-helper</v-icon
                        >
                      </v-list-item-icon>
                      <v-list-item-content class="text-left">
                        <v-list-item-title class="white-space">{{
                            feature.name
                          }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
                <v-card-actions class="custom-center justify-center">
                  <a
                      v-if="!plan.can_cancel"
                      class="btn cta"
                      :class="{ disabled: !plan.can_subscribe }"
                      @click="() => start_residential_checkout(plan.paddle_plan_id)"
                  >
                    {{ get_residential_subscribe_button_text(plan) }}
                  </a>
                  <a
                      v-else
                      class="btn cta error"
                      :class="{ disabled: plan.price === 0 }"
                      @click="show_residential_cancel_dialogue"
                  >
                    Cancel
                  </a>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item :key="2">
          <v-row no-gutters class="mb-4">
            <v-col
                class="pb-8"
                v-for="plan in datacenter_plans"
                :key="plan.id"
                lg="3"
                md="6"
                sm="16"
                cols="12"
            >
              <v-card class="pricing-item border-radius-8 mx-4 pb-4">
                <v-card-title class="box-shadow-none subscribed pricing-header pt-6" :style="[plan.can_cancel ? {'background-color': '#2ECC71'} : {}]">
                  <div class="pricing-title">{{ plan.name }}</div>
                  <div class="pricing-subtitle">
                    {{ plan.traffic_amount_gb | currency("", 0) }} GBs
                  </div>
                </v-card-title>
                <v-card-text class="pricing-body px-4">
                  <div class="plan-price">
                    <b v-if="plan.price !== 0">
                      <sup>$</sup>{{ (plan.price / 100) | currency("", 0) }}
                    </b>
                    <b v-else>Free</b>
                    <span :style="[plan.can_cancel ? {'color': '#2ECC71'} : {}]">Monthly</span> <br>
                    <span :style="{ color: '#000000a0' }"><sup>$</sup>{{ plan.price / plan.traffic_amount_gb / 100 }}/GB</span>
                  </div>
                  <v-list class="mx-0 px-0">
                    <v-list-item
                        class="height-48"
                        v-for="(feature, index) in plan.features"
                        :key="feature.name + index"
                    >
                      <v-list-item-icon class="mr-5 mt-3">
                        <v-icon v-if="feature.included" color="primary"
                        >mdi-check</v-icon
                        >
                        <v-icon v-else color="primary" class="lg--text"
                        >mdi-block-helper</v-icon
                        >
                      </v-list-item-icon>
                      <v-list-item-content class="text-left">
                        <v-list-item-title class="white-space">{{
                            feature.name
                          }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
                <v-card-actions class="custom-center justify-center">
                  <a
                      v-if="!plan.can_cancel"
                      class="btn cta"
                      :class="{ disabled: !plan.can_subscribe }"
                      @click="() => start_datacenter_checkout(plan.paddle_plan_id)"
                  >
                    {{ get_datacenter_subscribe_button_text(plan) }}
                  </a>
                  <a
                      v-else
                      class="btn cta error"
                      :class="{ disabled: plan.price === 0 }"
                      @click="show_datacenter_cancel_dialogue"
                  >
                    Cancel
                  </a>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    <div class="mt-4 mb-4">
      <h1 class="text-content-center">Need more? Order a custom plan</h1>
    </div>
    <div
      class="
        md-layout md-layout-item md-alignment-center-space-around
        custom-center
      "
    >
      <v-row no-gutters class="mb-4 justify-center">
        <v-col lg="3" md="6" sm="16" cols="12">
          <v-card class="pricing-item border-radius-8 mx-4 pb-0">
            <v-card-title class="box-shadow-none pricing-header pt-6">
              <div class="pricing-title">Custom plan</div>
              <div class="pricing-subtitle">
                Get in touch to discuss your needs
              </div>
            </v-card-title>
            <v-card-text class="pricing-body px-4">
              <div class="plan-price">
                <b class="fontlight--text">Custom</b>
                <span>Monthly</span>
              </div>
              <v-list class="mx-0 px-0">
                <v-list-item class="height-48 mx-0 px-0">
                  <v-list-item-icon class="mr-5 mt-3">
                    <v-icon color="primary">mdi-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="text-left">
                    <v-list-item-title class="white-space"
                      >Live calls integration</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="height-48 mx-0 px-0">
                  <v-list-item-icon class="mr-5 mt-3">
                    <v-icon color="primary">mdi-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="text-left">
                    <v-list-item-title class="white-space"
                      >Custom scraping code</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="height-48 mx-0 px-0">
                  <v-list-item-icon class="mr-5 mt-3">
                    <v-icon color="primary">mdi-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="text-left">
                    <v-list-item-title class="white-space"
                      >Personal recommendations</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="height-48 mx-0 px-0">
                  <v-list-item-icon class="mr-5 mt-3">
                    <v-icon color="primary">mdi-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="text-left">
                    <v-list-item-title class="white-space"
                      >Bulk pricing</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="height-48 mx-0 px-0">
                  <v-list-item-icon class="mr-5 mt-3">
                    <v-icon color="primary">mdi-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="text-left">
                    <v-list-item-title class="white-space"
                      >Custom proxy pools</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions class="custom-center justify-center">
              <a class="btn cta" @click="requestCustomPlan"> REQUEST </a>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div class="loading-overlay" v-if="loading">
      <v-progress-circular
        :size="50"
        :width="2"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-dialog v-model="show_subscription_created_dialog" max-width="550">
      <v-card>
        <v-card-title>
          Your subscription has been successfully created 🎉
        </v-card-title>
        <v-card-text>
          The changes will be applied within 15 minutes (usually almost instantly).
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            text
            @click="onSubscriptionChangedCreatedDialog"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_subscription_cancelled_dialog" max-width="550">
      <v-card>
        <v-card-title>
          Your subscription has been successfully cancelled 💔
        </v-card-title>
        <v-card-text>
          The changes will be applied within 15 minutes (usually almost instantly).
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            text
            @click="onSubscriptionChangedCancelDialog"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_residential_cancel_first_dialog" max-width="800">
      <v-card>
        <v-card-title> Please, cancel your current subscription </v-card-title>
        <v-card-text>
          <p>
            In order to start using new subscription, please, <b>cancel</b> your
            current subscription.
          </p>
          <p>
            This action will cancel renewal of your plan and you will be able to use it until the end of the billing cycle.
          </p>
          <p>
            Once subscribed again, current subscription GBs will be lost.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="show_residential_cancel_first_dialog = false">
            Continue using current plan
          </v-btn>
          <v-btn color="primary" text @click="onCurrentResidentialSubscriptionCancel">
            Cancel current subscription
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_cancel_first_dialog" max-width="800">
      <v-card>
        <v-card-title> Please, cancel your current subscription </v-card-title>
        <v-card-text>
          <p>
            In order to start using new subscription, please, <b>cancel</b> your
            current subscription.
          </p>
          <p>
            Remained API credits will <b>not</b> be transferred to the new
            subscription.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="show_cancel_first_dialog = false">
            Continue using current plan
          </v-btn>
          <v-btn color="primary" text @click="onCurrentSubscriptionCancel">
            Cancel current subscription
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_datacenter_cancel_first_dialog" max-width="800">
      <v-card>
        <v-card-title> Please, cancel your current subscription </v-card-title>
        <v-card-text>
          <p>
            In order to start using new subscription, please, <b>cancel</b> your
            current subscription.
          </p>
          <p>
            This action will cancel renewal of your plan and you will be able to use it until the end of the billing cycle.
          </p>
          <p>
            Once subscribed again, current subscription GBs will be lost.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="show_datacenter_cancel_first_dialog = false">
            Continue using current plan
          </v-btn>
          <v-btn color="primary" text @click="onCurrentDatacenterSubscriptionCancel">
            Cancel current subscription
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_cancel_dialog" max-width="800">
      <v-card>
        <v-card-title>You are going to cancel your current subscription</v-card-title>
        <v-card-text>
          <p>
            This action takes effect immediately and you will not be able to use <b>{{ current_subscription.remained_credits }}</b> remained credits.
          </p>
          <p>
            Remained API credits will <b>not</b> be transferred to the new
            subscription.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="show_cancel_dialog = false">
            Continue using current plan
          </v-btn>
          <v-btn color="primary" text @click="onCurrentSubscriptionCancel">
            Cancel current subscription
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_residential_cancel_dialog" max-width="800">
    <v-card>
      <v-card-title>You are going to cancel your current subscription</v-card-title>
      <v-card-text>
        <p>
          Your plan won't be renewed after the current billing cycle.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="show_residential_cancel_dialog = false">
          Continue using current plan
        </v-btn>
        <v-btn color="primary" text @click="onCurrentResidentialSubscriptionCancel">
          Cancel current subscription
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>
    <v-dialog v-model="show_datacenter_cancel_dialog" max-width="800">
      <v-card>
        <v-card-title>You are going to cancel your current subscription</v-card-title>
        <v-card-text>
          <p>
            Your plan won't be renewed after the current billing cycle.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="show_datacenter_cancel_dialog = false">
            Continue using current plan
          </v-btn>
          <v-btn color="primary" text @click="onCurrentDatacenterSubscriptionCancel">
            Cancel current subscription
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { delay } from "@/utils/common_utils";
import constants from "@/config/constants";

export default {
  name: "Subscriptions",
  data() {
    return {
      tabs: ['webscrapingapi', 'residential', 'datacenter'],
      current_tab: 0,
      loading: false,
      plans: [],
      residential_plans: [],
      datacenter_plans: [],
      current_subscription: null,
      current_residential_subscription: null,
      current_datacenter_subscription: null,
      show_cancel_first_dialog: false,
      show_residential_cancel_first_dialog: false,
      show_datacenter_cancel_first_dialog: false,
      show_subscription_created_dialog: false,
      show_subscription_cancelled_dialog: false,
      show_cancel_dialog: false,
      show_residential_cancel_dialog: false,
      show_datacenter_cancel_dialog: false,
    };
  },
  watch: {
    current_tab(newTab) {
      console.log(newTab);
      this.$router.push({ query: { tab: this.tabs[newTab] } });
      console.log(this.tabs[newTab]);
    },
  },
  methods: {
    get_subscribe_button_text(plan) {
      if (plan.price === 0) {
        if (
          this.current_subscription &&
          plan.name === this.current_subscription.plan.name
        ) {
          return "Subscribed";
        } else {
          return "Subscribe";
        }
      } else {
        return "Subscribe";
      }
    },
    get_residential_subscribe_button_text(plan) {
      if (plan.price === 0) {
        if (
            this.current_residential_subscription &&
            plan.name === this.current_residential_subscription.plan.name
        ) {
          return "Subscribed";
        } else {
          return "Subscribe";
        }
      } else {
        return "Subscribe";
      }
    },
    get_datacenter_subscribe_button_text(plan) {
      if (plan.price === 0) {
        if (
            this.current_residential_subscription &&
            plan.name === this.current_residential_subscription.plan.name
        ) {
          return "Subscribed";
        } else {
          return "Subscribe";
        }
      } else {
        return "Subscribe";
      }
    },
    get_available_plans() {
      this.loading = true;
      Promise.all([
        this.$store.dispatch("subscriptions/getPlans"),
        this.$store.dispatch("subscriptions/getResidentialPlans"),
        this.$store.dispatch("subscriptions/getDatacenterPlans"),
      ]).then(
        (res) => {
          this.loading = false;
          this.plans = res[0].data;
          this.residential_plans = res[1].data;
          this.datacenter_plans = res[2].data;
        },
        (err) => {
          this.loading = false;
          console.log(err);
        }
      );
    },
    get_current_subscription() {
      this.$store
        .dispatch("subscriptions/getCurrentSubscription")
        .then((res) => {
          this.current_subscription = res.data.subscriptions[0];
        }, console.log);
    },
    get_current_residential_subscription() {
      this.$store
        .dispatch("subscriptions/getCurrentResidentialSubscription")
        .then((res) => {
          this.current_residential_subscription = res;
        }, console.log);
    },
    get_current_datacenter_subscription() {
      this.$store
        .dispatch("subscriptions/getCurrentDatacenterSubscription")
        .then((res) => {
          this.current_datacenter_subscription = res;
        }, console.log);
    },
    get_current_user() {
      this.$store.dispatch("auth/get_user").then((res) => {
        this.user_email = res.data.email;
      }, console.log);
    },
    start_checkout(product_id) {
      if (this.current_subscription.plan.price > 0) {
        this.show_cancel_first_dialog = true;
      } else {
        // eslint-disable-next-line no-undef
        Paddle.Checkout.open({
          product: product_id,
          email: this.user_email,
          disableLogout: true,
          successCallback: (data) => {
            // eslint-disable-next-line no-undef
            trackConversion(data);
            const order_amount = (data.checkout.prices.vendor.total - data.checkout.prices.vendor.total_tax).toFixed(2)
            this.$gtag.event('conversion', {
              send_to: constants.GOOGLE_ADWORDS_CONVERSION_ID,
              value: order_amount,
              currency: 'USD'
            });
            this.show_subscription_created_dialog = true;
            this.$gtag.event(constants.ANALYTICS_EVENTS.CHECK_OUT_SUCCESS, {
              event_category: constants.ANALYTICS_EVENTS.PAYMENT_CATEGORY,
              value: product_id,
            });
          },
          closeCallback: () => {
            this.get_current_subscription();
            this.get_current_residential_subscription();
            this.get_current_datacenter_subscription();
            this.get_available_plans();
            this.$gtag.event(constants.ANALYTICS_EVENTS.CHECK_OUT_CANCELLED, {
              event_category: constants.ANALYTICS_EVENTS.PAYMENT_CATEGORY,
              value: product_id,
            });
          },
        });
      }
    },
    start_residential_checkout(product_id) {
      if (this.current_residential_subscription.recurring) {
        this.show_residential_cancel_first_dialog = true;
      } else {
        // eslint-disable-next-line no-undef
        Paddle.Checkout.open({
          product: product_id,
          email: this.user_email,
          disableLogout: true,
          successCallback: (data) => {
            // eslint-disable-next-line no-undef
            trackConversion(data);
            const order_amount = (data.checkout.prices.vendor.total - data.checkout.prices.vendor.total_tax).toFixed(2)
            this.$gtag.event('conversion', {
              send_to: constants.GOOGLE_ADWORDS_CONVERSION_ID,
              value: order_amount,
              currency: 'USD'
            });
            this.show_subscription_created_dialog = true;
            this.$gtag.event(constants.ANALYTICS_EVENTS.CHECK_OUT_SUCCESS, {
              event_category: constants.ANALYTICS_EVENTS.PAYMENT_CATEGORY,
              value: product_id,
            });
          },
          closeCallback: () => {
            this.get_current_subscription();
            this.get_current_residential_subscription();
            this.get_available_plans();
            this.$gtag.event(constants.ANALYTICS_EVENTS.CHECK_OUT_CANCELLED, {
              event_category: constants.ANALYTICS_EVENTS.PAYMENT_CATEGORY,
              value: product_id,
            });
          },
        });
      }
    },
    start_datacenter_checkout(product_id) {
      if (this.current_datacenter_subscription.recurring) {
        this.show_datacenter_cancel_first_dialog = true;
      } else {
        // eslint-disable-next-line no-undef
        Paddle.Checkout.open({
          product: product_id,
          email: this.user_email,
          disableLogout: true,
          successCallback: (data) => {
            // eslint-disable-next-line no-undef
            trackConversion(data);
            const order_amount = (data.checkout.prices.vendor.total - data.checkout.prices.vendor.total_tax).toFixed(2)
            this.$gtag.event('conversion', {
              send_to: constants.GOOGLE_ADWORDS_CONVERSION_ID,
              value: order_amount,
              currency: 'USD'
            });
            this.show_subscription_created_dialog = true;
            this.$gtag.event(constants.ANALYTICS_EVENTS.CHECK_OUT_SUCCESS, {
              event_category: constants.ANALYTICS_EVENTS.PAYMENT_CATEGORY,
              value: product_id,
            });
          },
          closeCallback: () => {
            this.get_current_subscription();
            this.get_current_residential_subscription();
            this.get_current_datacenter_subscription();
            this.get_available_plans();
            this.$gtag.event(constants.ANALYTICS_EVENTS.CHECK_OUT_CANCELLED, {
              event_category: constants.ANALYTICS_EVENTS.PAYMENT_CATEGORY,
              value: product_id,
            });
          },
        });
      }
    },
    show_cancel_dialogue() {
      this.show_cancel_dialog = true;
    },
    show_residential_cancel_dialogue() {
      this.show_residential_cancel_dialog = true;
    },
    show_datacenter_cancel_dialogue() {
      this.show_datacenter_cancel_dialog = true;
    },
    start_cancel(cancel_url, product_id) {
      // eslint-disable-next-line no-undef
      Paddle.Checkout.open({
        override: cancel_url,
        successCallback: () => {
          this.show_subscription_cancelled_dialog = true;
          this.$gtag.event(constants.ANALYTICS_EVENTS.CANCEL_SUCCESS, {
            event_category: constants.ANALYTICS_EVENTS.PAYMENT_CATEGORY,
            value: product_id,
          });
        },
        closeCallback: () => {
          this.get_current_subscription();
          this.get_current_residential_subscription();
          this.get_current_datacenter_subscription();
          this.get_available_plans();
          this.$gtag.event(constants.ANALYTICS_EVENTS.CANCEL_CANCELLED, {
            event_category: constants.ANALYTICS_EVENTS.PAYMENT_CATEGORY,
            value: product_id,
          });
        },
      });
    },
    get_available_plans_delayed() {
      this.loading = true;
      delay(4000).then(() => {
        this.get_current_subscription();
        this.get_current_residential_subscription();
        this.get_current_datacenter_subscription();
        this.get_available_plans();
      });
    },
    onCurrentSubscriptionCancel() {
      this.show_cancel_first_dialog = false;
      this.show_cancel_dialog = false;
      this.start_cancel(this.current_subscription.cancel_url);
    },
    onCurrentResidentialSubscriptionCancel() {
      this.show_residential_cancel_first_dialog = false;
      this.show_residential_cancel_dialog = false;
      this.start_cancel(this.current_residential_subscription.cancel_url);
    },
    onCurrentDatacenterSubscriptionCancel() {
      this.show_datacenter_cancel_first_dialog = false;
      this.show_datacenter_cancel_dialog = false;
      this.start_cancel(this.current_datacenter_subscription.cancel_url);
    },
    onSubscriptionChangedCancelDialog() {
      this.show_subscription_cancelled_dialog = false;
      this.get_available_plans_delayed();
    },
    onSubscriptionChangedCreatedDialog() {
      this.show_subscription_created_dialog = false;
      this.get_available_plans_delayed();
    },
    requestCustomPlan() {
      window.open(
        "mailto:support@scrapingant.com?subject=Custom Plan Order | ScrapingAnt"
      );
    },
  },
  mounted() {
    this.get_current_subscription();
    this.get_current_residential_subscription();
    this.get_current_datacenter_subscription();
    this.get_available_plans();
    this.get_current_user();

    const tab = this.$route.query.tab;
    if (this.tabs.indexOf(tab) !== -1) {
      this.current_tab = this.tabs.indexOf(tab);
    }
  },
};
</script>

<style scoped>
.md-list-item-text {
  white-space: initial;
}

.md-list-item-content > .md-icon:first-child {
  margin-right: 16px;
}

.md-list-item-content {
  padding: 4px 0;
}

.md-layout-item .custom-center {
  justify-content: center;
  padding-bottom: 25px;
}
.pricing-title {
  font-size: 32px !important;
}
.pricing-subtitle {
  font-size: 16px !important;
}
.pricing-title,
.pricing-subtitle {
  font-weight: 900 !important;
}

.pricing-item {
  box-shadow: 0 0 24px 0 rgb(0 0 0 / 15%) !important;
  background-color: #fff;
  border-radius: 8px 8px 0 0;
}

.pricing-item h3 {
  font-size: 32px;
  margin: 0;
}

.pricing-header {
  text-align: center;
  padding: 15px 0;
  color: #fff;
  background-color: #e2782f;
  display: block;
}

.pricing-body {
  padding: 15px 15px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.plan-price b {
  font-size: 48px;
  display: block;
  font-weight: 900;
  line-height: 1;
}

.plan-price b sup {
  font-size: 18px;
  margin-left: -15px;
  top: -1.1em;
}

.plan-features {
  text-align: left;
  margin: 25px 0;
}

.plan-features li + li {
  margin-top: 15px;
}

.plan-afterword {
  margin-top: 15px;
  font-size: 14px;
  font-weight: 300;
}
.custom-center .btn {
  background-color: #e2782f;
  color: #fff;
  border-radius: 8px;
  padding: 10px 25px;
  text-decoration: none;
  text-transform: uppercase;
  border: 2px solid #e2782f;
  transition: all 0.3s ease;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  display: inline-block;
}

.btn:hover {
  background-color: transparent;
  color: rgba(226, 120, 47, 0.8);
}

.btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.plan-price {
  margin-top: 40px;
}

.plan-price span {
  color: #e2782f;
  font-size: 18px;
}
</style>
